import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub5_1/96651ace1c81456be2b408cff621fc77_water__c1_w280_h397.jpg'


const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/expert/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'Best',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "전문가교육",
          subtitle: "전문가교육",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _createVNode(BoardNavbar),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "sub_subject" }, "전문가 과정", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("ul", { class: "line line4" }, [
                  _createElementVNode("li", null, "다중재능코칭 전문가교육"),
                  _createElementVNode("li", null, [
                    _createElementVNode("dl", { class: "line2" }, [
                      _createElementVNode("dt", null, "제목"),
                      _createElementVNode("dd", null, "다중재능코칭전문가교육 - 최고과정")
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("figure", null, [
                      _createVNode(_component_n_space, { justify: "center" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[1] || (_cache[1] = _createStaticVNode("<li data-v-71112b60><dl data-v-71112b60><dt data-v-71112b60>목적</dt><dd data-v-71112b60> 성장기 유소년, 청소년, 청년을 대상으로 최적의 학습 전략을 수립하고 진로를 안내하는 전문가 양성 교육과정으로, <br data-v-71112b60> PUTT을 활용한 ‘다중재능코칭 전문가’의 교수설계 및 강의 역량을 강화하는 데 목적이 있다. </dd></dl><dl data-v-71112b60><dt data-v-71112b60>목표</dt><dd data-v-71112b60> 목표1. 참여자는 PUTT의 핵심 개념과 용어를 명확하게 이해, 정의, 설명하는 기량을 높인다. <br data-v-71112b60> 목표2. 참여자는 PUTT의 구조, 문항, 범위 및 수준, 유형, 결과 분석, 그리고 직업군 등 전반에 대한 메타인지를 높인다. <br data-v-71112b60> 목표3. 참여자는 PUTT2.0 전문가 교육(초급 혹은 고급 과정)의 교수설계 및 수업 운영 제반 업무 등의 기량을 배양한다. </dd></dl><dl data-v-71112b60><dt data-v-71112b60>대상</dt><dd data-v-71112b60> • 교육학 및 심리학 관련 분야 전공자<br data-v-71112b60> • 교육 및 진로 상담 경력 3년 이상, 혹은 당 분야 박사학위 소지자 등<br data-v-71112b60> • ‘PUTT2.0 학습진로상담전문가 교육: 고급과정’ 이수자로, ‘다중재능코칭전문가 2급 자격증’ 취득한 자 </dd></dl><dl class=\"line2\" data-v-71112b60><dt data-v-71112b60>구분·시수</dt><dd data-v-71112b60> 직무연수, 30시간 (사전 과정 6시간 + 집중 과정 22시간 + 필기시험 1시간/실기시험 1시간) </dd></dl></li>", 1))
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div data-v-71112b60><ul class=\"line line4\" data-v-71112b60><li data-v-71112b60> 결과물<br data-v-71112b60> + 다중재능코칭전문가 1급 자격증 </li><li data-v-71112b60><dl class=\"line2\" data-v-71112b60><dt data-v-71112b60>구성</dt><dd data-v-71112b60> [사전 과정] <br data-v-71112b60> Ⅰ. PUTT2.0 결과 비교 분석<br data-v-71112b60> [집중 과정] <br data-v-71112b60> Ⅱ. 학문적 배경 •21세기 철학과 역량 •검사 이해 •결과리포트의 구성 및 해석, •상담 및 코칭<br data-v-71112b60> Ⅲ. 사례 분석 •사례 분석 - 발표 •사례 분석 - 논의<br data-v-71112b60> Ⅳ. 교수 설계 • 교수 설계 - 실습 •교수 설계 - 발표 •교수 설계 – 논의<br data-v-71112b60> ⅴ. 수업 계획 • 자료집 - 제작 •자료집 - 발표 </dd></dl></li></ul></div><div data-v-71112b60><ul class=\"line box22\" data-v-71112b60><li data-v-71112b60> 강의<br data-v-71112b60> + 검사 개발자<br data-v-71112b60> + ‘PUTT2.0 학습진로상담 전문가교<br data-v-71112b60> 육: 최고과정’ 이수자(1급 자격증 소지) </li><li data-v-71112b60><dl class=\"line2\" data-v-71112b60><dt data-v-71112b60>이수혜택</dt><dd data-v-71112b60> • ‘다중재능코칭전문가 1급 자격증’ 부여<br data-v-71112b60> • 검사 구매, 결과 해석 및 상담 자격<br data-v-71112b60> • 특강 자격: 학생 또는 학부모, 진로 상담 전문가 </dd></dl></li></ul></div>", 2)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Expert.Expert.Path}`
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("목록")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})